var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showArticles,
          expression: "showArticles"
        }
      ],
      staticClass: "cont_boardlist article_more_board",
      class: _vm.rootClass,
      style: _vm.rootStyle
    },
    [
      _c("strong", { staticClass: "screen_out" }, [_vm._v("하단 게시글 목록")]),
      _vm._v(" "),
      _vm.isSearch
        ? _c("search-title", {
            attrs: { query: _vm.query, isNicknameSearch: _vm.isNicknameSearch }
          })
        : _c("common-title", {
            attrs: { title: _vm.title, description: _vm.description }
          }),
      _vm._v(" "),
      _vm.isAlbum ? _c("album-article-list") : _c("common-article-list"),
      _vm._v(" "),
      _vm.showsMoveTopBtn
        ? _c("div", { staticClass: "move_top" }, [_vm._m(0)])
        : _vm._e(),
      _vm._v(" "),
      _c("layer-manager")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { attrs: { href: "#" } }, [
      _c("span", { staticClass: "ico_bbs ico_top" }),
      _vm._v("맨위로")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }